import { IconProp } from '@fortawesome/fontawesome-svg-core';
import * as styles from './Pill.css';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TMap } from '@client/new/helpers/types';
import { Discount } from '../../model/Discounts.model';
import { ForwardedProps } from './ListCellRenderer';
import { color, rgb } from '@design-system/tokens';

export type PillType = Discount['status'] | 'Neutral';

export type PillProps = ForwardedProps & {
  icon?: IconProp;
  type?: PillType;
  onClick?: () => void;
  content: string;
  backgroundColor?: keyof typeof color;
  maxWidth?: number | 'max-content';
};

const colorsMap: TMap<PillType, string> = {
  Active: '#C8EFCF',
  Inactive: '#EEEEEE',
  Expired: '#F5E5D2',
  'Limit reached': '#F5E5D2',
  Neutral: '#F8F8F8',
};

export const Pill = (p: PillProps) => (
  <div
    ref={p.tooltipRef}
    {...p.tooltipProps}
    className={styles.pillWrapper}
    data-testid={p['data-testid']}
    onClick={(e) => {
      if (!p.onClick) return;
      e.stopPropagation();
      p.onClick?.();
    }}
    style={{
      backgroundColor: p.backgroundColor
        ? rgb(p.backgroundColor)
        : colorsMap[p.type || 'Active'],
      ...(p.onClick ? { cursor: 'pointer' } : {}),
    }}
  >
    <Typography
      variant="body"
      fontWeight="bold"
      size="medium"
      as="div"
      className={styles.textWrapper}
      style={
        p.maxWidth
          ? {
              maxWidth:
                p.maxWidth === 'max-content' ? p.maxWidth : p.maxWidth + 'px',
            }
          : {}
      }
    >
      {p.content}
    </Typography>
    {p.icon ? (
      <FontAwesomeIcon
        color={'#5F1ECC'}
        icon={p.icon}
        style={{ width: '14px', height: '14px', fontWeight: 400 }}
      />
    ) : null}
  </div>
);
